import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  claimHistoryDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Client code"
          subtitle={claimHistoryDetails?.client_voucher?.client_code ? claimHistoryDetails?.client_voucher?.client_code : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Customer email"
          subtitle={claimHistoryDetails?.customer_email ? claimHistoryDetails?.customer_email : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="MLBB account ID"
          subtitle={claimHistoryDetails?.mlbb_account_id ? claimHistoryDetails?.mlbb_account_id : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="MLBB zone"
          subtitle={claimHistoryDetails?.mlbb_zone ? claimHistoryDetails?.mlbb_zone : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="MLWDP claim status"
          subtitle={claimHistoryDetails?.claim_status ? claimHistoryDetails?.claim_status : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="Reference"
          subtitle={claimHistoryDetails?.reference ? claimHistoryDetails?.reference : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className='mb-3'
          title="MLWDP invoice ID"
          subtitle={claimHistoryDetails?.mlwdp_invoice_id ? claimHistoryDetails?.mlwdp_invoice_id : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
